import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/counter-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/counter-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/counter-profiles/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/counter-profiles/${data.counter_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient.delete(`/api/counter-profiles/${id}`).then(response => Promise.resolve(response.data))
}

export const getFoodCourt = (Options = {}) => {
  return httpClient
    .get('/api/counter-profiles/food-courts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default { get, store, find, update, destroy, getFoodCourt }
